<template>
    <div class="indexClassifyBox">
        <div class="flexBox bg_white f10 myborderT tc lh30">
            <div class="flexBox-cell-33">
                <span class="classifySpan" v-on:click="typeListTab(1)"
                      :class="{'classifyCur_92fanli':styleName === 'main' && tabIndex===1,'classifyCur_damai':styleName === 'main_b' && tabIndex === 1,'classifyCur':styleName === 'main_c' && tabIndex === 1}">淘宝</span>
            </div>
            <div class="flexBox-cell-33">
                <span class="classifySpan" v-on:click="typeListTab(2)"
                      :class="{'classifyCur_92fanli':styleName === 'main' && tabIndex===2,'classifyCur_damai':styleName === 'main_b' && tabIndex === 2,'classifyCur':styleName === 'main_c' && tabIndex === 2}">京东</span>
            </div>
            <div class="flexBox-cell-33">
                <span class="classifySpan" v-on:click="typeListTab(3)"
                      :class="{'classifyCur_92fanli':styleName === 'main' && tabIndex===3,'classifyCur_damai':styleName === 'main_b' && tabIndex === 3,'classifyCur':styleName === 'main_c' && tabIndex === 3}">拼多多</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            styleName: {
                type: String,
                default: 'main'
            },
            tabIndex: {
                type: Number,
                default: 1
            }
        },
        methods: {
            typeListTab: function (index) {
                this.$emit('changeTabIndex', index);
            }
        }
    }
</script>

<style scoped>

</style>
